import { getBudgetTotals } from '../../Construction.utils';

const SUMMARY_ROW_ID = 'construction-budget-total';

export const getBudgetTableData = lines => {
  const totals = getBudgetTotals(lines);

  const rows = lines.map(line => ({
    id: line.id,
    costCode: line.costCode,
    description: line.description,
    budgeted: line.budgeted,
    fundedToDate: line.fundedToDate,
    thisDraw: line.thisDraw,
    remaining: line.remaining,
    percentComplete: line.percentComplete,
    isOverBudget: line.isOverBudget ?? line.remaining < 0,
  }));

  const summaryRow = {
    id: SUMMARY_ROW_ID,
    isSummaryRow: true,
    costCode: 'Total',
    description: `${lines.length} line items`,
    budgeted: totals.budgeted,
    fundedToDate: totals.fundedToDate,
    thisDraw: totals.thisDraw,
    remaining: totals.remaining,
    percentComplete: totals.percentComplete,
  };

  return [...rows, summaryRow];
};

export const getOverBudgetLine = lines =>
  lines.find(line => line.isOverBudget ?? line.remaining < 0) ?? null;
